<script>
import compoment from '@/components/draggable/CustomComponents/Checkbox/DSimpleCheckboxPreview'
export default {
  name: 'DReleasePlatformPreview',
  extends: compoment
}
</script>
